import { FEATURE_STORAGE_KEY } from './feature.constants'
import type { FeatureEnv } from './feature.types'

function isSessionStorageAvailable(): boolean {
  if (typeof window === 'undefined') return false
  try {
    const test = '__feature_test__'
    sessionStorage.setItem(test, '1')
    sessionStorage.removeItem(test)
    return true
  } catch {
    return false
  }
}

export function getStoredFeature(): FeatureEnv {
  if (!isSessionStorageAvailable()) return null
  return sessionStorage.getItem(FEATURE_STORAGE_KEY) || null
}

export function setStoredFeature(value: string): void {
  if (!isSessionStorageAvailable()) return
  sessionStorage.setItem(FEATURE_STORAGE_KEY, value)
}

export function clearStoredFeature(): void {
  if (!isSessionStorageAvailable()) return
  sessionStorage.removeItem(FEATURE_STORAGE_KEY)
}
